module.exports = __webpack_public_path__ + "img/test.4c316f87.svg";